import { Device, AuthTypes, Entitlements } from 'enums';
import appConfig from '../config';

const {
    secureCdnHost,
    cdnHost
} = appConfig;

export const GRAPHQL_API_KEY = '0dbf88e8-cc6d-41da-aa83-18b5c630bc5c';
export const SHIELD_API_KEY = '5p8m6dw513q716wt2os04mec3';

export const MVPD_PREVIOUS_KEY = '@watch:MVPD_PREVIOUS';
export const GEO_LOCATION_KEY = '@watch:GEO_LOCATION';
export const SUB_KEY = '@watch:SUB';
export const SESSION_TOKEN_KEY = '@watch:SESSION_TOKEN';
export const USER_TRACKING_KEY = '@watch:USER_TRACKING';
export const PREAUTH_LOCALSTORAGE_KEY = '@watch:PREAUTHZ';
export const FORCE_REFRESH_TOKEN_RETRY_KEY = '@watch:TOKEN_REFRESH_RETRY';
export const PRODUCT_API_CONFIGURATION = {
    dev: {
        serviceUrl: '//watch.product.api.espnsb.com',
        internalServiceUrl: '//watch.product.api.espnsb.com'
    },
    qa: {
        serviceUrl: '//watch.product.api.espnqa.com',
        internalServiceUrl: '//watch.product.api.espnqa.com'
    },
    staging: {
        serviceUrl: '//watch.product.api.preview.espn.com',
        internalServiceUrl: '//watch.product.api.preview.espn.com'
    },
    prod: {
        serviceUrl: '//watch.product.api.espn.com',
        internalServiceUrl: '//watchproductapi.prod.internal.geo.espn.com'
    }
};

export const GRAPHQL_API_CONFIGURATION = {
    dev: {
        serviceUrl: '//watch.graph.api.espnsb.com'
    },
    qa: {
        serviceUrl: '//watch.graph.api.espnqa.com'
    },
    staging: {
        serviceUrl: '//watch.graph.api.preview.espn.com'
    },
    prod: {
        serviceUrl: '//watch.graph.api.espn.com'
    }
};

export const LISTINGS_API_CONFIGURATION = {
    dev: {
        serviceUrl: '//broadband.espnqa.com/espn360/apis/v1/watch',
        internalServiceUrl: '//broadband.espnqa.com/espn360/apis/v1/watch'
    },
    qa: {
        serviceUrl: '//api-app.espn.com/v1/watch',
        internalServiceUrl: '//api-app.espn.com/espn360/apis/v1/watch'
    },
    staging: {
        serviceUrl: '//api-app.espn.com/v1/watch',
        internalServiceUrl: '//api-app.espn.com/espn360/apis/v1/watch'
    },
    prod: {
        serviceUrl: '//api-app.espn.com/v1/watch',
        internalServiceUrl: '//api-app.espn.com/espn360/apis/v1/watch'
    }
};

// list of varnish x-deivce values
// https://github.disney.com/SEESPN/seespn_varnish/blob/4257d10478d4556183497914c22157aa08761613/files/default/etc/varnish/vcl/device.vcl#L50
// Map of X-Device values to supports device values of PageAPI
export const xDeviceMap = {
    pc: Device.DESKTOP,
    'pc-generic': Device.DESKTOP,
    handset: Device.HANDSET,
    mobile: Device.HANDSET,
    'mobile-generic': Device.HANDSET,
    'mobile-smartphone': Device.HANDSET,
    tablet: Device.TABLET
};

export const unknownAuthStates = [
    `unknown_${AuthTypes.ISP}`,
    `unknown_${AuthTypes.MVPD}`,
    `unknown_${Entitlements.ESPN_PLUS}`,
    `unknown_${Entitlements.ESPN_PLUS_NHL}`,
    `unknown_${Entitlements.ESPN_PLUS_MLB}`
];

export const clientRenderRoutes = [
    'home',
    'espnplus',
    'product'
];

export const NO_CATEGORY_ID_MAPPINGS = {
    pt: 'outros',
    en: 'others',
    es: 'otros'
};

export const loadingImageUrl = `${cdnHost}/watchespn/images/espn-watch-placeholder.png`;
export const loadingImageUrlDark = `${cdnHost}/watchespn/images/espn-watch-placeholder-dark.png`;
export const secureLoadingImageUrl = `${secureCdnHost}/watchespn/images/espn-watch-placeholder.png`;
export const secureLoadingImageUrlDark = `${secureCdnHost}/watchespn/images/espn-watch-placeholder-dark.png`;
export const promoImageUrl = `${cdnHost}/watchespn/images/watch-promotional.jpg`;
export const securePromoImageUrl = `${secureCdnHost}/watchespn/images/watch-promotional.jpg`;
export const notFoundUrl = 'https://www.espn.com/404';

export const UPCOMING_MINUTES_WINDOW = 30;

export const BAM_PROXY_IFRAME_ID = 'bam-proxy-iframe';
export const BAM_PROMO_IFRAME_ID = 'bam-promo-iframe';
export const BAM_PAYWALL_IFRAME_ID = 'bam-paywall-iframe';

export const dotComNielsenData = {
    espnuk: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    general: {
        ci: 'us-600140',
        assetid: 'N/A',
        segB: 'N/A',
        sfcode: 'dcr',
        segA: 'N/A',
        section: 'N/A',
        segC: 'N/A',
        apn: 'espnCOM'
    },
    espnza: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espnau: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espn: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espnin: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    fantasy: {
        apid: 'P302B69D5-F1DD-4E7A-BF8D-3E60F0EB5E5A',
        vc: 'c07'
    },
    watchespn: {
        apid: 'P07264C85-15CD-4A80-8E56-B5BFA6D93296',
        vc: 'b01'
    },
    espndeportes: {
        apid: 'P890E2723-EDBC-4CCE-96BA-F35EA3E50650',
        vc: 'c02'
    },
    espnfc: {
        apid: 'PE6995AAE-0C49-4372-B5E7-54C61BFE2AA5',
        vc: 'c03'
    },
    cricinfo: {
        apid: 'PED8CDAC2-F114-41BE-8B98-AFA06FAEA06E',
        vc: 'c04'
    }
};

export const NIELSEN_APPID_EPLUS = 'P3AB2D9A0-5877-41BF-A1AB-D0D590F79234';
export const NIELSEN_APPID_TVE = 'P31187EE2-AC6E-46CB-BB54-D07591BED067';



// WEBPACK FOOTER //
// ./app/constants.js